import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import { PageHero, SectionHead } from "../components/UI";
import { IconCheck } from "../components/Icons";

const Yes = () => <IconCheck size={16} />;

const plans = [
  {
    name: "Cơ bản",
    desc: "Cho nhóm nhỏ bắt đầu số hoá nội dung họp.",
    cta: "Liên hệ báo giá",
    feat: false,
    items: [
      ["Ghi âm trực tiếp & tải file", true],
      ["Phiên âm tiếng Việt theo người nói", true],
      ["Tóm tắt cuộc họp bằng AI", true],
      ["Xuất biên bản Word/PDF", true],
      ["Quản lý nhiệm vụ sau họp", false],
      ["Hồ sơ giọng nói (voiceprint)", false],
      ["Nhật ký kiểm toán & phân quyền", false],
      ["Triển khai trong hạ tầng nội bộ", false],
    ],
  },
  {
    name: "Chuyên nghiệp",
    desc: "Cho phòng ban, văn phòng cần quy trình hoàn chỉnh.",
    cta: "Yêu cầu demo",
    feat: true,
    items: [
      ["Ghi âm trực tiếp & tải file", true],
      ["Phiên âm tiếng Việt theo người nói", true],
      ["Tóm tắt cuộc họp bằng AI", true],
      ["Xuất biên bản Word/PDF", true],
      ["Quản lý nhiệm vụ sau họp", true],
      ["Hồ sơ giọng nói (voiceprint)", true],
      ["Nhật ký kiểm toán & phân quyền", true],
      ["Triển khai trong hạ tầng nội bộ", false],
    ],
  },
  {
    name: "Tổ chức",
    desc: "Cho cơ quan, đơn vị triển khai nội bộ và SSO.",
    cta: "Liên hệ tư vấn",
    feat: false,
    items: [
      ["Toàn bộ tính năng gói Chuyên nghiệp", true],
      ["Triển khai trong hạ tầng nội bộ", true],
      ["Đăng nhập tập trung (SSO)", true],
      ["Mẫu biên bản tuỳ chỉnh theo đơn vị", true],
      ["Quản trị nhiều phòng ban", true],
      ["Hỗ trợ & đào tạo triển khai", true],
      ["Cam kết mức dịch vụ (SLA)", true],
      ["Tích hợp theo yêu cầu", true],
    ],
  },
];

const cmpRows = [
  ["Ghi âm trực tiếp & tải file", true, true, true],
  ["Phiên âm phân biệt người nói", true, true, true],
  ["Tóm tắt & phân tích AI", true, true, true],
  ["Trích nhiệm vụ kèm thời hạn", false, true, true],
  ["Sinh dự thảo kết luận theo mẫu", true, true, true],
  ["Xuất Word / PDF", true, true, true],
  ["Hồ sơ giọng nói (voiceprint)", false, true, true],
  ["Phân quyền & nhật ký kiểm toán", false, true, true],
  ["Đăng nhập tập trung (SSO)", false, false, true],
  ["Triển khai hạ tầng nội bộ", false, false, true],
  ["Mẫu & tích hợp tuỳ chỉnh", false, false, true],
];

const faqs = [
  ["Giá được tính như thế nào?", "Báo giá theo quy mô đơn vị, số người dùng và hình thức triển khai (đám mây hay nội bộ). Hãy liên hệ để nhận phương án phù hợp nhất."],
  ["Có dùng thử trước khi quyết định không?", "Có. Chúng tôi demo trực tiếp trên một tình huống họp thực tế của đơn vị bạn trước khi triển khai chính thức."],
  ["Dữ liệu cuộc họp được lưu ở đâu?", "Tuỳ gói: lưu trên nền tảng được quản lý, hoặc triển khai hoàn toàn trong hạ tầng nội bộ của đơn vị với gói Tổ chức."],
  ["Phiên âm hỗ trợ tiếng Việt tốt không?", "Hệ thống tối ưu cho tiếng Việt, phân biệt người nói và cho phép hiệu chỉnh, chuẩn hoá thuật ngữ bằng AI."],
  ["Cuộc họp rất dài có xử lý được không?", "Được. Với bản ghi dài, hệ thống xử lý theo từng phần; cấu hình giới hạn dung lượng được điều chỉnh theo nhu cầu khi triển khai."],
];

export function Pricing() {
  return (
    <>
      <PageHero
        eyebrow="Bảng giá"
        title="Chọn mức phù hợp với quy mô và cách triển khai"
        sub="Ba gói được thiết kế theo mức độ hoàn chỉnh của quy trình — từ số hoá cơ bản đến triển khai nội bộ toàn diện."
      />

      <section className="section">
        <div className="container">
          <div className="price-grid">
            {plans.map((p, i) => (
              <Reveal key={i} className={`plan ${p.feat ? "feat" : ""}`} delay={i * 80}>
                <div className="pname">{p.name}</div>
                <div className="pdesc">{p.desc}</div>
                <div className="price">
                  <span className="amt">Liên hệ</span>
                  <span className="per">/ theo quy mô</span>
                </div>
                <ul>
                  {p.items.map(([t, on], j) => (
                    <li key={j} className={on ? "" : "off"}>
                      <IconCheck size={16} />
                      {t as string}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/lien-he"
                  className={`btn ${p.feat ? "btn-primary" : "btn-ghost"} btn-block`}
                >
                  {p.cta}
                </Link>
              </Reveal>
            ))}
          </div>
          <Reveal>
            <div className="note" style={{ marginTop: 26, textAlign: "center", borderLeft: "none", borderTop: "3px solid var(--brand)" }}>
              Mọi gói đều bao gồm phiên âm tiếng Việt, tóm tắt AI và xuất biên bản. Báo giá cuối
              cùng phụ thuộc quy mô người dùng và hình thức triển khai.
            </div>
          </Reveal>
        </div>
      </section>

      <section className="section soft">
        <div className="container">
          <SectionHead center eyebrow="So sánh chi tiết" title="Tính năng theo từng gói" />
          <Reveal style={{ overflowX: "auto" }}>
            <table className="cmp">
              <thead>
                <tr>
                  <th>Tính năng</th>
                  <th>Cơ bản</th>
                  <th>Chuyên nghiệp</th>
                  <th>Tổ chức</th>
                </tr>
              </thead>
              <tbody>
                {cmpRows.map((r, i) => (
                  <tr key={i}>
                    <td>{r[0] as string}</td>
                    {[1, 2, 3].map((c) => (
                      <td key={c}>
                        {r[c] ? (
                          <span className="yes">
                            <IconCheck size={17} />
                          </span>
                        ) : (
                          <span className="no">—</span>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </Reveal>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHead center eyebrow="Câu hỏi thường gặp" title="Những điều cần biết trước khi bắt đầu" />
          <div className="faq">
            {faqs.map(([q, a], i) => (
              <Reveal key={i} as="details" className="qa" delay={i * 40}>
                <summary>{q}</summary>
                <div className="a">{a}</div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
